/**************************************************
 * Nombre:       Formulario_Suscriptores
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid} from "@mui/material";
import IngresoTexto from "../../Modulo_formularios/Componentes/IngresoTexto";
import {AccountCircleOutlined, BakeryDining, Google, PhoneAndroid} from "@mui/icons-material";
import IngresoFecha from "../../Modulo_formularios/Componentes/IngresoFecha";

const Formulario_Suscriptores = ({...props}) => {

    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTexto Icono={AccountCircleOutlined} nombre={'Nombre'} dato={'nombre'} {...props}
                                  requerido={'El Nombre es requerido'}
                    />
                </Grid>

                <Grid container size={6}>
                    <IngresoTexto Icono={PhoneAndroid} nombre={'Celular'} dato={'celular'} {...props}
                    />
                </Grid>

                <Grid container size={6}>
                    <IngresoFecha Icono={BakeryDining} nombre={'fechaCumple'} dato={'fechaCumple'} {...props}
                    />
                </Grid>


                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTexto Icono={Google} nombre={'Correo de Google'} dato={'correo'} {...props}
                    />
                </Grid>


            </Grid>

        </form>

    )

}
export default Formulario_Suscriptores